import type { TRuleWithTheme } from '@ackee/fela';

export const extendContainer: TRuleWithTheme = () => ({
    position: 'relative',
    overflow: 'visible',
    tabletLarge: {
        paddingTop: '10.25rem',
        paddingBottom: '12.5rem',
    },
});

const titleBase = {
    maxWidth: '86.1875rem',
    marginBottom: '0',
    marginTop: '0',

    tabletLarge: {
        fontSize: '4.875rem',
    },
};

export const extendTitle: TRuleWithTheme = ({ theme: { colors } }) => ({
    ...titleBase,
    color: colors.black,
    marginBottom: '0.5rem',
    textTransform: 'uppercase',
});

export const link: TRuleWithTheme = () => ({
    textDecoration: 'none',
});

export const extendLinkTitle: TRuleWithTheme = ({ theme: { colors } }) => ({
    ...titleBase,
    lineHeight: 1.4,
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s',
    willChange: 'color',

    ':hover': {
        color: colors.fuchsia,
    },
});
